import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "281",
  "slug": "spot-uk-from-satellite-imagery",
  "title": "How to Recognise the United Kingdom in Satellite Images",
  "excerpt": "Great Britain has rugged uplands in Scotland and Wales, with broader lowlands across much of southern and eastern England.",
  "date": "2026-04-18",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/uk.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Great Britain has rugged uplands in Scotland and Wales, with broader lowlands across much of southern and eastern England. Its coast includes estuaries, peninsulas, and islands that help establish regional position. Northern Ireland lies on a separate island, so an overview of Britain alone does not show the whole UK."
    },
    {
      "type": "heading",
      "text": "Upland west and lower eastern Britain"
    },
    {
      "type": "paragraph",
      "text": "Compare the Scottish Highlands with eastern England at the same scale. Then identify the sea separating Great Britain from Ireland."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Ireland shares green fields, hedges, and parts of the Atlantic landscape. Similar farmland occurs in western Europe. Roundabouts and roof colours are not sufficient to distinguish countries from above."
    }
  ],
  "imageAlt": "the United Kingdom regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
